export function overflowFunction (booleanValue) {
  booleanValue
    ? document.body.style.overflow = 'hidden'
    : document.body.style.overflow = 'auto'
}
